import ComponentMap from "./component-map"
import { carousel__content, carousel__navigation, nav_prev, nav_next } from "./carousel.module.scss"

const Carousel = (props) => {
  const content = props.content
  return (
    <>
      {content.section_content.map((section, index) => {
        var Cname = section.template ? ComponentMap[section.template] : ComponentMap[section.__typename]
        return (
          <div
            key={section.contentful_id}
            className={`${carousel__content} carousel__${content.contentful_id}--${index}`}
          >
            <Cname content={section} index={index} />
          </div>
        )
      })}
      <div className={`${carousel__navigation} carousel__navigation--${content.contentful_id}`}>
        <button className={nav_prev} data-arrow="0">
          <span>Prev</span>
        </button>
        {content.section_content.map((section, index) => {
          return (
            <button key={section.contentful_id} data-stat={index}>
              <span>{index}</span>
            </button>
          )
        })}
        <button className={nav_next} data-arrow="2">
          <span>Next</span>
        </button>
      </div>
      <div className="nimbus--tail"></div>
    </>
  )
}

export default Carousel
